// Libraries
import { keyframes } from 'styled-components'

export const FloatDownUp = keyframes`
  0% {
    transform: translateY(0px);
  }
  25% {
    transform: translateY(-18px);
  }
  75% {
    transform: translateY(18px);
  }
  100% {
    transform: translateY(0px);
  }
`

export const FloatUpDown = keyframes`
  0% {
    transform: translateY(0px);
  }
  25% {
    transform: translateY(18px);
  }
  75% {
    transform: translateY(-18px);
  }
  100% {
    transform: translateY(0px);
  }
`

export const FloatSlightly = keyframes`
	0% {
		transform: translateY(3px);
	}
	50% {
    transform: translateY(-3px);
	}
	100% {
		transform: translateY(3px);
	}
`

export const CarouselLeft = keyframes`
	0% {
    transform: translateX(30px);
	}
  10%{
    transform: translateX(0px);
  }
	100% {
		transform: translateX(0px);
	}
`

export const CarouselRight = keyframes`
	0% {
    transform: translateX(29px);
	}
  10%{
    transform: translateX(0px);
  }
	100% {
		transform: translateX(0px);
	}
`

export const LogoLeft = keyframes`
  0% {
    transform: translate(-380px, 140px);
  }
  30% {
    transform: translate(5px, -5px);
  }
  50% {
    transform: translate(-5px, 5px);
  }
  70% {
    transform: translate(5px, -5px);
  }
  100% {
    transform: translate(0px, 0px);
  }
`

export const LogoLeftShade = keyframes`
  0% {
    transform: translate(-380px, 140px);
  }
  35% {
    transform: translate(5px, -5px);
  }
  55% {
    transform: translate(-5px, 5px);
  }
  75% {
    transform: translate(5px, -5px);
  }
  100% {
    transform: translate(0px, 0px);
  }
`

export const LogoRight = keyframes`
  0% {
    transform: translate(350px, -140px);
  }
  30% {
    transform: translate(-5px, 5px);
  }
  50% {
    transform: translate(5px, -5px);
  }
  70% {
    transform: translate(-5px, 5px);
  }
  100% {
    transform: translate(0px, 0px);
  }
`

export const LogoRightShade = keyframes`
  0% {
    transform: translate(350px, -140px);
  }
  30% {
    transform: translate(5px, -5px);
  }
  50% {
    transform: translate(-5px, 5px);
  }
  70% {
    transform: translate(5px, -5px);
  }
  100% {
    transform: translate(0px, 0px);
  }
`

export const Pop1 = keyframes`
  0% {
    transform: scale(0);
  }
  30%{
    transform: scale(1.1);
  }
  50%{
    transform: scale(0.9);
  }
  70%{
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`

export const Pop2 = keyframes`
  0% {
    transform: scale(0);
  }
  30%{
    transform: scale(0.9);
  }
  50%{
    transform: scale(1.1);
  }
  70%{
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
`

export const PopBig = keyframes`
  0% {
    transform: scale(0);
  }
  30%{
    transform: scale(1.5);
  }
  50%{
    transform: scale(0.5);
  }
  70%{
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
`

export const GhostFloat = keyframes`
  0% {
    transform: translateY(0px) scale(1);
  }
  25% {
    transform: translateY(-18px) scale(0.97);
  }
  50% {
    transform: translateY(18px) scale(1.04);
  }
  75% {
    transform: translateY(-18px) scale(0.97);
  }
  100% {
    transform: translateY(0px) scale(1);
  }
`

export const PopAboutUs = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.5)
  }
  80%{
    opacity: 1;
    transform: scale(1.05)
  }
  100%{
    opacity: 1;
    transform: scale(1)
  }
`

export const PopProjects = keyframes`
  0% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`

export const Shining = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.2;
  }
  25% {
    transform: scale(0.95);
    opacity: 0.7;
  }
  75% {
    transform: scale(0.90);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
`

export const ShiningShadow = keyframes`
  0% {
    box-shadow: 0 0 18px #686FAC;
  }
  50%{
    box-shadow: 0 0 32px #686FAC;
  }
  100%{
    box-shadow: 0 0 18px #686FAC;
  }
`

export const Path = keyframes`
  0% {
    opacity: 0; 
    transform: translateY(100px) scale(1);
  }
  100% {
    opacity: 1; 
    transform: translateY(0px) scale(1.1);
  }
`
